import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { ConfigService } from '@polaris-customerweb/sharedcomponents.config';
import { ImageCdnSrcDirective } from '@polaris-customerweb/sharedcomponents.shared';
import { map } from 'rxjs/operators';
import { MobileAppCtaComponent } from 'src/app/components/shared/components/mobile-app-cta/mobile-app-cta.component';
import { PlanRideButtonComponent } from 'src/app/components/shared/components/plan-ride-button/plan-ride-button.component';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';
import { AppState } from 'src/app/models/app-state';
import { selectVehiclesForUser } from 'src/app/state/vehicle';

@Component({
    imports: [
        AsyncPipe,
        ImageCdnSrcDirective,
        MobileAppCtaComponent,
        PlanRideButtonComponent,
        RouterLink,
        AnalyticsDirective,
    ],
    selector: 'rdx-cta',
    styleUrls: ['./cta.component.scss'],
    templateUrl: './cta.component.html',
})
export class CtaComponent {
    showVehicleUpdate$;
    isIndian: boolean;
    isOffRoad: boolean;

    constructor(
        configService: ConfigService,
        private router: Router,
        private store: Store<AppState>
    ) {
        this.isIndian = configService.isIndian;
        this.isOffRoad = configService.isOffRoad;

        this.showVehicleUpdate$ = this.store.select(selectVehiclesForUser).pipe(
            map((vehicles) => {
                if (
                    vehicles.length > 0 &&
                    !vehicles.some((vehicle) => vehicle.hasDisplay)
                ) {
                    return false;
                }
                return true;
            })
        );
    }

    navigateToUrl(url: string): void {
        void this.router.navigateByUrl(url);
    }
}
